import Avatar, { AvatarProps } from '@mui/material/Avatar';
import { SxProps } from '@mui/material/styles';
import { ImageOptimized } from './image/ImageOptimized';

export type AvatarNextProps = Omit<AvatarProps, 'sx'> & {
  objectFit?: ImageProps['objectFit'];
  sx?: SxProps & object;
  eagerLoad?: boolean;
};

export function AvatarNext({
  src,
  alt,
  objectFit = 'cover',
  eagerLoad = false,
  sx = {},
  ...props
}: AvatarNextProps) {
  if (src && src !== 'DEFAULT_IMAGE') {
    try {
      return (
        <Avatar
          {...props}
          sx={{
            background: 'none',
            border: `1.5px solid rgba(255, 255, 255, 0.2)`,
            '& img': {
              borderRadius: '50%',
            },
            ...sx,
          }}
        >
          <ImageOptimized
            src={src}
            alt={alt}
            layout="fill"
            objectFit={objectFit}
            loading={eagerLoad ? 'eager' : 'lazy'}
          />
        </Avatar>
      );
    } catch (error) {
      console.dir(error);
    }
  }
  return <Avatar {...props} sx={sx} />;
}
